// Mirrors the server-side rules in portal-generic-api/services/asset/assetKeyUtils.js

const VALID_NAME_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9 ._()-]*$/;

const RESERVED_TOP_LEVEL_NAMES = ['manage'];

export const isValidAssetName = (name) => {
  if (!name || typeof name !== 'string') return false;
  return VALID_NAME_REGEX.test(name);
}

export const isReservedAssetName = (name) => {
  return RESERVED_TOP_LEVEL_NAMES.indexOf(String(name || '').toLowerCase()) > -1;
}

export const getParentPath = (key = '') => {
  const segments = key.split('/');
  segments.pop();
  return segments.join('/');
}
